<template>
  <HeaderView/>
  <router-view/>
  <FooterView/>
</template>
<script setup>
import HeaderView from "./views/HeaderView.vue";
import FooterView from "./views/FooterView.vue";

</script>
<style>
html {
  font-size: max(15px, 2vh);
  user-select: none;
}

body {
  font-size: 1rem;
}

* {
  box-sizing: border-box;
  padding: 0;
  margin: 0;
}

a {
  text-decoration: none;
  color: inherit;
  cursor: auto;
}
</style>